import React, { Fragment, useContext, useEffect, useState } from 'react';
import { Col, Card, CardHeader, Table, Form, FormGroup, Label, Input, ModalFooter, Row } from 'reactstrap';
import { Btn } from '../../AbstractElements';
import { useDispatch, useSelector } from 'react-redux';
import CommonModal from '../../Components/Modals/modal';
import Pagination from '../../Components/Pagination/Pagination';
import Empty from '../../Components/Empty/Index';
import SweetAlert from 'sweetalert2';
import { getCategory } from '../../store/categorySlice';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { getTestSeries, ModalToggle, isOpenModal, addTestSeries, isOpenStatusModal, statusToggle, statusUpdateTestSeries, statusDeleteTestSeries, isImageOpenModal, updateTestSeriesImage, updateTestSeries, } from '../../store/testSeriesSlice';
import NoImage from '../../assets/images/noimage.png';
import Dropzone from 'react-dropzone-uploader';
import { useLocation, useNavigate } from 'react-router';
import CustomizerContext from '../../_helper/Customizer';


const TestSeriesTable = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const { layoutURL } = useContext(CustomizerContext);
  const storeVar = useSelector(state => state.testSeries)
  const categoryVar = useSelector(state => state.category)
  const Imagetoggle = () => dispatch(isImageOpenModal());
  const dispatch = useDispatch();
  const toggle = () => dispatch(ModalToggle());
  const statusModalToggle = () => dispatch(statusToggle());
  const [stateStatus, setStateStatus] = useState('active');
  const [categoryId, setcategoryId] = useState('')
  const [submit, setSubmit] = useState(false);
  const [typingTimer, setTypingTimer] = useState(null);
  const typingDelay = 800;
  const [formVar, setFormVar] = useState({
    keyword: '',
    limit: 30,
    offset: 0,
    currentPage: 1,
    status: 'active',
    modalTitle: null,
    editState: false,
    bannerFile: null,
    bannerImageURL: null,
    testId: '',
    title: '',
    categoryId: '',
    description: '',
    brochureLink: '',
  });

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get("id") || "";
    setcategoryId(id);
    dispatch(getTestSeries(formVar.limit, formVar.offset, formVar.status, formVar.keyword, id))
    dispatch(getCategory(100, 0, '', ''))
  }, [location.search, dispatch]);


  const pageChange = (page) => {
    const offset = formVar.limit * (page - 1)
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      currentPage: page,
      offset: offset
    }))
    dispatch(getTestSeries(formVar.limit, offset, formVar.status, formVar.keyword, categoryId))
  };
  const searchState = (e) => {
    setFormVar((prevFormVar) => ({ ...prevFormVar, keyword: e.target.value }))
    searchWithDelay(e.target.value)
  }
  const searchWithDelay = (keyword) => {
    clearTimeout(typingTimer);
    const timer = setTimeout(() => {
      dispatch(getTestSeries(formVar.limit, formVar.offset, formVar.status, keyword, categoryId))
    }, typingDelay);
    setTypingTimer(timer);
  };
  const handleCategoryChange = (e) => {
    setcategoryId(e.target.value)
    dispatch(getTestSeries(formVar.limit, formVar.offset, formVar.status, formVar.keyword, e.target.value))
  };
  const handleInputChange = (e) => {
    setFormVar((prevFormVar) => ({ ...prevFormVar, status: e.target.value }))
    dispatch(getTestSeries(formVar.limit, formVar.offset, e.target.value, formVar.keyword, categoryId))
  };
  const EditToggleModal = (data) => {
    dispatch(isOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: true,
      testId: data._id,
      modalTitle: 'Edit Course',
      title: data.title,
      categoryId: data.categoryId._id,
      description: data.description,
      brochureLink: data.brochureLink,
    }))
  }
  const AddToggleModal = () => {
    dispatch(isOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: false,
      modalTitle: 'Add Course',
      title: '',
      categoryId: categoryId,
      description: '',
    }))
  }
  const onValueChange = (event) => {
    setStateStatus(event.target.value)
  }
  const statusToggleModal = (data) => {
    dispatch(isOpenStatusModal(true))
    setStateStatus(data.status)
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      testId: data._id,
    }))
  }

  const submitMenu = () => {


    if (testNameValid() || testSeriesValid() || descriptionValid() || brochureLinkValid()) {
      setSubmit(true)
      return null
    }
    setSubmit(false)

    if (formVar.editState) {
      dispatch(updateTestSeries(formVar.testId, { title: formVar.title, categoryId: formVar.categoryId, description: formVar.description, brochureLink: formVar.brochureLink }))
    } else {
      dispatch(addTestSeries({ title: formVar.title, categoryId: formVar.categoryId, description: formVar.description, brochureLink: formVar.brochureLink }))
    }
  }
  const submitStatus = () => {
    dispatch(statusUpdateTestSeries({ id: formVar.testId, status: stateStatus }))
  }

  const testNameValid = () => {
    if (!formVar.title) {
      return "Name is required";
    }
  }
  const testSeriesValid = () => {
    if (!formVar.categoryId) {
      return "Exam Series is required";
    }
  }
  const brochureLinkValid = () => {
    if (!formVar.brochureLink) {
      return "Brochure Link is required";
    }
  }
  const descriptionValid = () => {
    if (!formVar.description) {
      return "Description is required";
    }
  }

  const DeleteModel = (data) => {
    SweetAlert.fire({
      title: 'Are you sure?',
      text: 'Once deleted, you will not be able to recover this file!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    })
      .then((result) => {
        if (result.value) {
          dispatch(statusDeleteTestSeries({ id: data._id, status: 'deleted' }))
        }
      });
  }

  const onChange = (editor) => {
    const evt = editor.getData()
    setFormVar((prevFormVar) => ({ ...prevFormVar, description: evt }))
  };
  const onFocus = (editor) => {
    const evt = editor.getData()
    setFormVar((prevFormVar) => ({ ...prevFormVar, description: evt }))
  }

  const ImageEditBannerModal = (data) => {
    dispatch(isImageOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      testId: data._id,
      modalTitle: 'Update Icon',
      bannerFile: null,
      bannerImageURL: null
    }))
  }
  const handleChangeStatus = ({ meta, file }, status) => {
    if (status === 'done') {
      const reader = new FileReader();
      reader.onload = (e) => {
        setFormVar((prevFormVar) => ({
          ...prevFormVar,
          bannerImageURL: e.target.result,
        }))
      };
      reader.readAsDataURL(file);
      setFormVar((prevFormVar) => ({
        ...prevFormVar,
        bannerFile: file,
      }))
    } else if (status === "removed") {
      setFormVar((prevFormVar) => ({
        ...prevFormVar,
        bannerFile: null,
        bannerImageURL: null,
      }))
    }
  };
  const filesValid = () => {
    if (!formVar.bannerFile) {
      return "Files is required";
    }
  }
  const submitImage = () => {
    if (filesValid()) {
      setSubmit(true)
      return null
    }

    setSubmit(false)
    dispatch(updateTestSeriesImage(formVar.testId, formVar.bannerFile))
  }
  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <CardHeader>
            <Row>
              <Col md="4">
                <Input className="form-control" placeholder='Serch..' type="text" id="yourInputId"
                  value={formVar.keyword} onChange={(e) => searchState(e)}
                />
              </Col>
              <Col md="3">
                <Input className="form-control form-control-inverse btn-square" name="select" type="select"
                  value={categoryId} onChange={handleCategoryChange}>
                  <option value=''>All</option>
                  {categoryVar?.categoryData?.map((item, index) => (
                    <option key={index} value={item._id}>{item.name}</option>
                  ))}
                </Input>
              </Col>
              <Col md="3">
                <Input className="form-control form-control-inverse btn-square" name="select" type="select"
                  value={formVar.status} onChange={handleInputChange}>
                  <option value='active'>ACTIVE</option>
                  <option value='pending'>PENDING</option>
                </Input>
              </Col>
              <Col md="2" className='d-flex justify-content-end align-items-center'>
                <div className="text-end border-2 w-100">
                  <Btn attrBtn={{ color: 'info-gradien', className: 'w-100', size: 'sm', onClick: AddToggleModal }}>
                    Add Course
                  </Btn>
                </div>
              </Col>
            </Row>

          </CardHeader>
          <div className='table-responsive'>
            <Table hover={true} className='table-border-horizontal table-light'>
              <thead>
                <tr>
                  <th scope='col'>Sl.No</th>
                  <th scope='col'>Name</th>
                  <th scope='col'>Test Series</th>
                  <th scope='col'>Icon</th>
                  <th scope='col'>Status</th>
                  <th scope='col'>Action</th>
                </tr>
              </thead>
              <tbody>
                {storeVar.testSeriesData?.map((item, index) => (
                  <tr key={index}>
                    <th scope='row'>{index + 1}</th>
                    <td>{item.title}</td>
                    <td>{item.categoryId.name}</td>
                    <td className='w-25'>
                      {item.image ? <img className='w-75 h-5-r' src={item.image} alt="" /> : <img className='w-75 h-5-r' src={NoImage} alt="" />}
                    </td>
                    <td>
                      {
                        item.status === 'active' && <>
                          <span className={`font-success rounded-1 p-1 me-2 d-flex align-items-center`}>
                            <i className="fa fa-check-circle-o fa-lg" aria-hidden="true"></i>
                            &nbsp; <span>Active</span>
                          </span>
                        </>
                      }
                      {
                        item.status === 'pending' && <>
                          <span className={`font-warning rounded-1 p-1 me-2 d-flex align-items-center`}>
                            <i className="fa fa-clock-o fa-lg" aria-hidden="true"></i>
                            &nbsp; <span>Pending</span>
                          </span>
                        </>
                      }
                      {
                        item.status === 'DEACTIVE' && <>
                          <span className={`font-danger w-50 rounded-1 p-1 me-2 d-flex align-items-center`}>
                            {item.status === 'DEACTIVE' && (
                              <i className="fa fa-times-circle-o fa-lg" aria-hidden="true"></i>
                            )}
                            &nbsp; <span>{item.status}</span>
                          </span>
                        </>
                      }
                    </td>
                    <td>
                      <div className='d-flex gap-3 align-items-center'>
                        <div className='cursor-pointer bg-light-primary font-primary action-icon p-1 rounded'>
                          <i className="fa fa-edit" style={{ fontSize: '24px' }} onClick={(e) => EditToggleModal(item)}></i>
                          <div className="tooltipCustom">Edit</div>
                        </div>

                        <div className='cursor-pointer bg-light-primary font-secondary action-icon p-1 rounded'>
                          <i className="fa fa-book" style={{ fontSize: '24px' }} onClick={(e) => navigate('/mock-test/' + layoutURL + '?id=' + item._id)}></i>
                          <div className="tooltipCustom">Mock Test</div>
                        </div>
                        <div className='cursor-pointer bg-light-primary font-warning action-icon p-1 rounded'>
                          <i className="fa fa-calendar" style={{ fontSize: '24px' }} onClick={(e) => navigate('/previous-year/' + layoutURL + '?id=' + item._id)}></i>
                          <div className="tooltipCustom">Previous Year</div>
                        </div>
                        <div className='cursor-pointer bg-light-primary font-success action-icon p-1 rounded'>
                          <i className="fa fa-video-camera" style={{ fontSize: '24px' }} onClick={(e) => navigate('/recorded-class/' + layoutURL + '?id=' + item._id)}></i>
                          <div className="tooltipCustom">Recorded Class</div>
                        </div>
                        <div className='cursor-pointer bg-light-primary font-secondary action-icon p-1 rounded'>
                          <i className="fa fa-play-circle" style={{ fontSize: '24px' }} onClick={(e) => navigate('/live-class/' + layoutURL + '?id=' + item._id)}></i>
                          <div className="tooltipCustom">Live Class</div>
                        </div>
                        <div className='cursor-pointer bg-light-primary font-primary action-icon p-1 rounded'>
                          <i className="fa fa-book" style={{ fontSize: '24px' }} onClick={(e) => navigate('/enotes/' + layoutURL + '?id=' + item._id)}></i>
                          <div className="tooltipCustom">Enote</div>
                        </div>
                        <div className='cursor-pointer font-warning action-icon p-1 rounded'>
                          <i className="fa fa-picture-o" style={{ fontSize: '24px' }} onClick={(e) => ImageEditBannerModal(item)} />
                          <div className="tooltipCustom">Update Exam Thumbnail</div>
                        </div>
                        <div className='cursor-pointer bg-light-info font-info action-icon p-1 rounded'>
                          <i className="fa fa-toggle-on" style={{ fontSize: '24px' }} onClick={(e) => statusToggleModal(item)}></i>
                          <div className="tooltipCustom">Status Update</div>
                        </div>
                        <div className='cursor-pointer bg-light-info font-danger action-icon p-1 rounded'>
                          <i className="fa fa-trash" style={{ fontSize: '24px' }} onClick={(e) => DeleteModel(item)}></i>
                          <div className="tooltipCustom">Delete</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {
            storeVar.totalTestSeries <= 0 && (
              <Empty />
            )
          }
        </Card>
        {
          storeVar.totalTestSeries > 0 &&
          <Pagination currentPage={formVar.currentPage} totalItem={storeVar.totalTestSeries}
            itemsPerPage={formVar.limit} showEllipsisAfter={true} visiblePageCount={3} onPageChange={pageChange} />
        }
      </Col>
      <CommonModal isOpen={storeVar.isOpenModal} title={formVar.modalTitle} toggler={toggle} size={'lg'}>
        <Form>
          <FormGroup>
            <Label className="col-form-label" for="recipient-name">Name</Label>
            <Input className="form-control" type="text" placeholder='Enter Exam Name' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, title: e.target.value }))} value={formVar.title} />
            {submit && testNameValid() ? <span className='d-block font-danger'>{testNameValid()}</span> : ""}
            <Col md='12'>
              <Label className="col-form-label" for="recipient-name">Exam Series</Label>
              <select className="form-control form-control-inverse " name="select" type="select"
                value={formVar.categoryId} onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, categoryId: e.target.value }))}>
                <option value="" >Select Exam Series</option>
                {categoryVar?.categoryData?.map((item, index) => (
                  <option key={index} value={item._id}>{item.name}</option>
                ))}
              </select>
              {submit && testSeriesValid() ? <span className='d-block font-danger'>{testSeriesValid()}</span> : ""}
            </Col>
            <Label className="col-form-label" for="recipient-name">Brochure Link</Label>
            <Input className="form-control" type="text" placeholder='Enter Brochure Link' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, brochureLink: e.target.value }))} value={formVar.brochureLink} />
            {submit && brochureLinkValid() ? <span className='d-block font-danger'>{brochureLinkValid()}</span> : ""}
            <Label className="col-form-label" for="recipient-name">Description</Label>
            <CKEditor
              editor={ClassicEditor}
              data={formVar.description || ''}
              onReady={editor => {
                onFocus(editor)
              }}
              onChange={(event, editor) => {
                onChange(editor);
              }}
              onBlur={(event, editor) => {
              }}
              onFocus={(event, editor) => {
                onFocus(editor)
              }}

            />
            {submit && descriptionValid() ? <span className='d-block font-danger'>{descriptionValid()}</span> : ""}
          </FormGroup>
        </Form>
        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: toggle }} >Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitMenu }}>Save Changes</Btn>
        </ModalFooter>
      </CommonModal>
      <CommonModal isOpen={storeVar.isStatusOpenModal} title={'Status'} toggler={statusModalToggle} >
        <Col>
          <div className='d-flex m-15 m-checkbox-inline justify-content-center custom-radio-ml'>
            <div className='radio radio-primary'>
              <Input id='radioinline1' type='radio' className="radio_animated" name='radio1' checked={stateStatus === 'active'} onChange={onValueChange} value='active' />
              <Label className='mb-0' for='radioinline1'>
                <span className='digits'>ACTIVE</span>
              </Label>
            </div>
            <div className='radio radio-primary'>
              <Input id='radioinline3' type='radio' className="radio_animated" name='radio3' checked={stateStatus === 'pending'} onChange={onValueChange} value='pending' />
              <Label className='mb-0' for='radioinline3'>
                <span className='digits'>PENDING</span>
              </Label>
            </div>
          </div>
        </Col>
        <ModalFooter className='justify-content-center'>
          <Btn attrBtn={{ color: 'secondary', onClick: statusModalToggle }} >Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitStatus }}>Save Changes</Btn>
        </ModalFooter>
      </CommonModal>
      <CommonModal isOpen={storeVar.isImageOpenModal} title={formVar.modalTitle} toggler={Imagetoggle} >
        <Form>
          <FormGroup>
            {
              formVar.bannerImageURL && <>
                <div className='d-flex justify-content-center h-10-r'>
                  <img className=' h-100' src={formVar.bannerImageURL} alt="" />
                </div>
              </>
            }
            <Label className="col-form-label" for="recipient-name">Update Image</Label>
            <Dropzone
              className='dropzone dz-clickable'
              onChangeStatus={handleChangeStatus}
              maxFiles={1}
              multiple={false}
              // canCancel={false}
              accept="image/*"
              inputContent='Drop A File'
              styles={{
                dropzone: { width: '100%', height: 150 },
                dropzoneActive: { borderColor: 'green' },
              }}
            />
            {submit && filesValid() ? <span className='d-block font-danger'>{filesValid()}</span> : ""}
          </FormGroup>

        </Form>
        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: Imagetoggle }} >Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitImage }}>Save Changes</Btn>

        </ModalFooter>
      </CommonModal>

    </Fragment>
  );
};

export default TestSeriesTable;
